import { render, staticRenderFns } from "./PaymentMethodEdit.vue?vue&type=template&id=0a865406"
import script from "./PaymentMethodEdit.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports